import React, { memo } from 'react';
import './Card.css';

const Card = memo(({ 
  children, 
  className = '', 
  hover = true,
  padding = 'medium'
}) => {
  const cardClasses = [
    'card',
    hover ? 'card--hover' : '',
    `card--padding-${padding}`,
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={cardClasses}>
      {children}
    </div>
  );
});

Card.displayName = 'Card';

export default Card;
